<template>
    <div class="source">{{source}}</div>
</template>

<script>
export default {
  name: 'messageSource',
  props: {
    source: String
  }
};
</script>

<style scoped lang="scss">
    .source {
        padding: 3px;
        font-size: 0.75em;
        white-space: pre;
    }
</style>
